import Store from "@/inside/models/Filter/Store";

export default {
    getters: {
        /**
         * Returns filters store.
         * @return {Store}
         */
        store(state) {
            return state;
        },
        /**
         * Returns excluded action tag IDs as a direct reactive dependency.
         * @return {any[]}
         */
        excludedTagIds(state) {
            return state.actionTag.excludedValues;
        },
        /**
         * @param state Store
         */
        active(state) {
            let activeFiltersCategories = [];
            if (!state.textbases.isEmpty) {
                activeFiltersCategories.push("sites");
            }
            if (!state.actionTag.isEmpty) {
                activeFiltersCategories.push("tags");
            }
            if (!state.actionDuePeriod.isEmpty()) {
                activeFiltersCategories.push("actiondates");
            }

            if (!state.actionPriority.isEmpty) {
                activeFiltersCategories.push("priority");
            }

            return activeFiltersCategories;
        }
    },
    namespaced: true,
    state: new Store()
}
